/* NK — défilement automatique du carrousel "Vos retours" (page produit) */
(function () {
  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initCarousel(wrap) {
    if (wrap.dataset.nkAutoplay) return;
    wrap.dataset.nkAutoplay = '1';

    var track = wrap.querySelector('.carousel-track') || wrap.firstElementChild;
    if (!track) return;

    var DELAY = 2600;
    var RESUME_AFTER = 3500;
    var timer = null;
    var resumeTimer = null;
    var paused = false;
    var inView = true;

    function itemStep() {
      var item = track.querySelector('.carousel-item');
      if (!item) return wrap.clientWidth * 0.8;
      var style = getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 0) || 0;
      return item.getBoundingClientRect().width + gap;
    }

    function tick() {
      if (paused || !inView || reducedMotion()) return;
      var step = itemStep();
      var atEnd = wrap.scrollLeft + wrap.clientWidth >= wrap.scrollWidth - 2;
      if (atEnd) {
        wrap.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        wrap.scrollTo({ left: wrap.scrollLeft + step, behavior: 'smooth' });
      }
    }

    function start() {
      stop();
      if (reducedMotion()) return;
      timer = setInterval(tick, DELAY);
    }
    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function pauseTemporarily() {
      paused = true;
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { paused = false; }, RESUME_AFTER);
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (evt) {
      wrap.addEventListener(evt, pauseTemporarily, { passive: true });
    });
    wrap.addEventListener('mouseenter', function () { paused = true; });
    wrap.addEventListener('mouseleave', function () {
      if (resumeTimer) clearTimeout(resumeTimer);
      paused = false;
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { inView = e.isIntersecting; });
      }, { threshold: 0.15 }).observe(wrap);
    }

    start();
  }

  function boot() {
    document.querySelectorAll('.carousel-wrapper').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
